import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-applications',
  templateUrl: './default-applications.component.html',
  styleUrls: ['./default-applications.component.scss']
})
export class DefaultApplicationsComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
